import { photos } from '../assets/photos'

const SHOTS = [
	{ photo: photos.moten, label: 'Möt experter och utställare' },
	{ photo: photos.besokare, label: 'Få inspiration och nya perspektiv' },
	{ photo: photos.meditation, label: 'Delta i föredrag och workshops' },
	{ photo: photos.scenen, label: 'Träffa likasinnade och bli en del av gemenskapen' },
]

// Rendered width of one square tile, per breakpoint in tickets.css: four columns in the
// 1080px content box, two below 980px, one below 640px.
const TILE_WIDTHS = [
	['(max-width: 640px)', '100vw - 40px'],
	['(max-width: 980px)', '50vw - 30px'],
	[null, '260px'],
]

// object-fit: cover fills the square by height when the photo is landscape, so the
// browser needs a source that much wider than the tile.
const tileSizes = (aspect) => {
	const scale = Math.max(1, aspect)
	return TILE_WIDTHS.map(([query, width]) => {
		const length = `calc((${width}) * ${scale.toFixed(3)})`
		return query ? `${query} ${length}` : length
	}).join(', ')
}

const ExperienceRow = () => (
	<section className='hx-section'>
		<div className='hx-wrap'>
			<div className='hx-lede'>
				<h2>Mer än en mässa, en upplevelse</h2>
				<p>
					På Harmoni Expo möts människor, idéer och möjligheter. Här kan du utforska, prova, lyssna,
					handla och fylla på med ny energi.
				</p>
			</div>
			<ul className='hx-shots'>
				{SHOTS.map((shot) => (
					<li key={shot.label} className='hx-shot'>
						<img
							src={shot.photo.src}
							srcSet={shot.photo.srcSet}
							sizes={tileSizes(shot.photo.aspect)}
							alt={shot.label}
							loading='lazy'
							decoding='async'
						/>
						<span className='hx-shot__label'>{shot.label}</span>
					</li>
				))}
			</ul>
		</div>
	</section>
)

export default ExperienceRow
